/** EditBusiness.jsx – Patched Final Version */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function EditBusiness() {
  const { id } = useParams();
  const navigate = useNavigate();
 

  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Load listing data
  useEffect(() => {
    async function load() {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/lawn-mowing/business/${id}`);

        if (!res.data.success) {
          setError("Business not found.");
        } else {
          setFormData(res.data.listing);
        }
      } catch (err) {
        console.error("LOAD ERR:", err);
        setError("Failed to load listing.");
      }
      setLoading(false);
    }

    load();
  }, [id]);


  /** Update form fields */
  const updateField = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  /** SAVE CHANGES (PATCH FIXED) */
  const saveChanges = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      // 🔥 CLEAN DATA — ONLY WHAT BACKEND ACCEPTS
      const cleaned = {
        business_title: formData.business_title,
        business_description: formData.business_description,
        price: formData.price,
        total_cut_value: formData.total_cut_value,
        yearly_revenue: formData.yearly_revenue,
        clients_count: formData.clients_count,
        suburb: formData.suburb,
        state: formData.state,
        postcode: formData.postcode,
        vehicle_included: Number(formData.vehicle_included),
        vehicle_details: formData.vehicle_details || "",
        trailer_included: Number(formData.trailer_included),
        trailer_details: formData.trailer_details || "",
        equipment_included: Number(formData.equipment_included),
        equipment_details: formData.equipment_details || "",
        enquiry_only: Number(formData.enquiry_only)
      };

      const res = await axios.put(
        `${API_BASE_URL}/api/lawn-mowing/business/edit/${id}`,
        cleaned,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        alert("Business updated successfully.");
        navigate("/my-listings");
      } else {
        setError(res.data.message || "Failed to save changes.");
      }

    } catch (err) {
      console.error("SAVE ERR:", err);
      setError("Server error saving changes.");
    }

    setSaving(false);
  };


  if (loading) return <p>Loading...</p>;
  if (!formData) return <p>{error}</p>;

  const input = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "40px auto",
        padding: "25px",
        background: "white",
        borderRadius: "12px",
        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
      }}
    >
      <h1 style={{ color: "#2e7d32", marginBottom: "15px" }}>Edit Business Listing</h1>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={saveChanges}>
        {/* Title */}
        <label>Business Title</label>
        <input
          name="business_title"
          style={input}
          value={formData.business_title}
          onChange={updateField}
        />

        {/* Price */}
        <label>Sale Price ($)</label>
        <input
          name="price"
          type="number"
          style={input}
          value={formData.price}
          onChange={updateField}
        />

        {/* Cut Value */}
        <label>Total Cut Value ($)</label>
        <input
          name="total_cut_value"
          type="number"
          style={input}
          value={formData.total_cut_value}
          onChange={updateField}
        />

        {/* Revenue */}
        <label>Yearly Revenue ($)</label>
        <input
          name="yearly_revenue"
          type="number"
          style={input}
          value={formData.yearly_revenue}
          onChange={updateField}
        />

        {/* Clients */}
        <label>Clients Count</label>
        <input
          name="clients_count"
          type="number"
          style={input}
          value={formData.clients_count}
          onChange={updateField}
        />

        {/* Location */}
        <label>Suburb</label>
        <input
          name="suburb"
          style={input}
          value={formData.suburb}
          onChange={updateField}
        />

        <label>State</label>
        <select
          name="state"
          style={input}
          value={formData.state}
          onChange={updateField}
        >
          <option value="">Select</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="WA">WA</option>
          <option value="SA">SA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label>Postcode</label>
        <input
          name="postcode"
          style={input}
          value={formData.postcode}
          onChange={updateField}
        />

        {/* Description */}
        <label>Description</label>
        <textarea
          name="business_description"
          rows="4"
          style={input}
          value={formData.business_description}
          onChange={updateField}
        />

        {/* Vehicle Included */}
        <label>Vehicle Included?</label>
        <select
          name="vehicle_included"
          style={input}
          value={formData.vehicle_included}
          onChange={updateField}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.vehicle_included == 1 && (
          <>
            <label>Vehicle Details</label>
            <textarea
              name="vehicle_details"
              rows="2"
              style={input}
              value={formData.vehicle_details || ""}
              onChange={updateField}
            />
          </>
        )}

        {/* Trailer Included */}
        <label>Trailer Included?</label>
        <select
          name="trailer_included"
          style={input}
          value={formData.trailer_included}
          onChange={updateField}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.trailer_included == 1 && (
          <>
            <label>Trailer Details</label>
            <textarea
              name="trailer_details"
              rows="2"
              style={input}
              value={formData.trailer_details || ""}
              onChange={updateField}
            />
          </>
        )}

        {/* Equipment Included */}
        <label>Equipment Included?</label>
        <select
          name="equipment_included"
          style={input}
          value={formData.equipment_included}
          onChange={updateField}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {formData.equipment_included == 1 && (
          <>
            <label>Equipment Details</label>
            <textarea
              name="equipment_details"
              rows="2"
              style={input}
              value={formData.equipment_details || ""}
              onChange={updateField}
            />
          </>
        )}

        {/* Enquiry Only */}
        <label>Enquiry Only?</label>
        <select
          name="enquiry_only"
          style={input}
          value={formData.enquiry_only}
          onChange={updateField}
        >
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>

        {/* Save Button */}
        <button
          type="submit"
          disabled={saving}
          style={{
            width: "100%",
            padding: "14px",
            background: "#2e7d32",
            color: "white",
            border: "none",
            borderRadius: "8px",
            marginTop: "20px",
            cursor: "pointer",
          }}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </form>
    </div>
  );
}
